import { FC } from "react";

import { LayoutProps } from "./Layout.types";

export const DefaultLayout: FC<LayoutProps> = ({ children, bgColor }) => {
  // const [scrollPosition, setScrollPosition] = useState(0);

  return (
    // <main
    //   className={`min-w-full h-screen ${bgColor} overflow-y-auto pb-20`}
    //   onScroll={e => setScrollPosition(e.currentTarget.scrollTop)}
    // >
    //   <TopNavigation shadow={scrollPosition > 0} />
    //   {children}
    // </main>
    <main className={`w-full h-screen 2xl:container mx-auto ${bgColor} pb-20 bg-[#f2f2f2]`}>{children}</main>
  );
};
